import { registerRootComponent } from 'expo';
import { LogBox, Platform } from 'react-native';
import App from './App';
import { getCanonicalWebUrl } from './src/lib/canonical-web-redirect';

LogBox.ignoreLogs(['Request failed with status code 401', 'Require cycle:', 'process.env.EXPO_OS is not defined']);

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
const canonicalUrl =
  Platform.OS === 'web' && typeof window !== 'undefined' ? getCanonicalWebUrl(window.location) : undefined;
if (canonicalUrl) {
  window.location.replace(canonicalUrl);
} else {
  registerRootComponent(App);
}
